import { render } from "./portraits-info.vue?vue&type=template&id=02b6de7c&scoped=true"
import script from "./portraits-info.vue?vue&type=script&lang=js"
export * from "./portraits-info.vue?vue&type=script&lang=js"

import "./portraits-info.vue?vue&type=style&index=0&id=02b6de7c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b6de7c"]])

export default __exports__